import { useEffect } from "react";
import { Button, Modal, Form, message, Row, Col, Input } from "antd";
import Moment from "react-moment";
import postDataTrace from "../../../../services/postDataTrace";

export default function UpdateWip({
  isVisible,
  selected,
  setVisible,
  handleFetchBookings,
}: any) {
  const [form] = Form.useForm();

  const onSubmit = async () => {
    let { wip } = form.getFieldsValue();
    const data = { wip };
    const booking_id = selected._id;
    const uri = `bookings/${booking_id}/update/wip`;
    const response = await postDataTrace(data, uri);
    if (response.success) {
      message.success("Updated successfully");
    } else {
      message.error("Something went wrong");
    }
    setVisible(false);
    await handleFetchBookings();
  };

  const hideModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="WIP Number"
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="UpdateWip"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Add WIP
        </Button>,
      ]}
    >
      <Form
        id="UpdateWip"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout={"vertical"}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.slottime?.starttime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
          </div>
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="wip"
              label="WIP Number"
              rules={[
                {
                  required: true,
                  message: "Please enter WIP Number",
                },
              ]}
            >
              <Input placeholder="WIP" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
